import { render, staticRenderFns } from "./LedgerHistoryTabs.vue?vue&type=template&id=052ffdc2&scoped=true"
import script from "./LedgerHistoryTabs.vue?vue&type=script&lang=js"
export * from "./LedgerHistoryTabs.vue?vue&type=script&lang=js"
import style0 from "./LedgerHistoryTabs.vue?vue&type=style&index=0&id=052ffdc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ffdc2",
  null
  
)

export default component.exports